'use strict';

angular.module('controllers')
	.directive('openCloseActionCard', function() {
		return {
			restrict: 'EA',
			link: function(scope, element, attrs){
				element.bind('click', function (event) {
					angular.element(document.querySelector('md-card#'+attrs.openCloseActionCard)).toggleClass('show hide');
				});
			}
		}

	});
